import InfantilEspacial from "./InfantilEspacial";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "infantil-espacial",
  tipoEvento: "infantil",
  tipoEtiqueta: "Cumpleaños infantil",
  nombre: "Aventura Espacial",
  descripcion:
    "Misión espacial suave y redondeada: cohete y planeta con anillo como insignia de edad, estrellas titilantes y foto en escotilla. Ilustraciones originales, sin personajes comerciales.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    espacio: "/miniaturas/infantil-espacial-espacio.jpg",
    aurora: "/miniaturas/infantil-espacial-aurora.jpg",
    amanecer: "/miniaturas/infantil-espacial-amanecer.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: InfantilEspacial,
};
